import Joi from '@hapi/joi'

export const CardPrintFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
        "any.required": `Operation Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Collection Point required`,
        "any.required": `Collection Point required`
    }),
    employeeTypeID: Joi.number().invalid(0).required().label("Employee Type").messages({
        "any.invalid": `Employee Type required`,
        "any.required": `Employee Type required`
    })
}